export const TEXT = {
  MAX: {
    ACRONYM: 10,
    CODE: 10,
    NAME: 50,
    SHORT: 20,
    MEDIUM: 128,
    LONG: 255,
    ZIP_CODE: 10,
    ADDRESS: 255,
    EMAIL: 255,
  },
} as const;

export const NUMBER = {
  KEYS: {
    PREVENTS: ['e', 'E', '+', '-'],
  },
  LIMIT: {
    SHORT: 9,
    MEDIUM: 20,
    LONG: 30,
  },
} as const;

export const MONEY = {
  LIMIT: {
    MAX: 1000000,
    MIN: 0,
    MAX_DIGIT: 7,
  },
};
